import React from 'react';

// The main App component for the privacy policy page.
// This is a complete, self-contained React component ready for use.
const FacebookPrivacyPolicy = () => {
  return (
    // Main container with full height and width, centered content, and a dark background.
    <div className="min-h-screen bg-gray-900 text-gray-100 p-4 md:p-8 flex items-center justify-center font-sans antialiased">
      {/* Container for the privacy policy content with a rounded, shaded card style. */}
      <div className="bg-gray-800 rounded-2xl shadow-2xl p-6 md:p-10 max-w-4xl w-full">
        {/* Title of the privacy policy. */}
        <h1 className="text-4xl md:text-5xl font-extrabold text-blue-400 mb-6 text-center leading-tight">
          Privacy Policy
        </h1>
        <p className="text-gray-400 text-sm md:text-base text-center mb-8">
          Last Updated: July 20, 2024
        </p>

        {/* Section for Introduction */}
        <div className="space-y-6">
          <h2 className="text-2xl md:text-3xl font-bold text-gray-200">1. Introduction</h2>
          <p className="text-gray-300">
            Welcome to <span className="font-semibold text-white">Zero Plus Hub Messenger Bot</span>. This Privacy Policy outlines how we collect, use, and store information from users who interact with our bot on the Facebook Messenger platform. Our primary goal is to provide seamless auto-reply and customer support services while ensuring your privacy is protected.
          </p>

          {/* Section for Information Collected */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-200">2. Information We Collect</h2>
          <p className="text-gray-300">
            We collect the following types of information when you interact with our bot:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
            <li><strong className="text-white">Messages:</strong> We collect text messages and audio messages that you send to the bot. This is essential for providing our auto-reply and support services.</li>
            <li><strong className="text-white">Public Profile Information:</strong> We may access your public Facebook profile information, such as your user ID and name, to personalize your experience and identify you for support purposes.</li>
          </ul>
          <p className="text-red-400 font-medium mt-4">
            <strong className="text-red-300">Important:</strong> We do not collect or store any sensitive personal data, such as passwords, credit card numbers, or other financial information.
          </p>

          {/* Section for How Information is Used */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-200">3. How We Use Your Information</h2>
          <p className="text-gray-300">
            The information we collect is used solely for the following purposes:
          </p>
          <ul className="list-disc list-inside space-y-2 text-gray-300 ml-4">
            <li><strong className="text-white">To Provide Services:</strong> To process your messages and generate appropriate replies for auto-reply and customer support.</li>
            <li><strong className="text-white">To Improve the Bot:</strong> To analyze message patterns and improve the accuracy and efficiency of our bot's responses.</li>
          </ul>
          <p className="text-gray-300 mt-4">
            We do not share your information with any third-party services or individuals.
          </p>

          {/* Section for Data Storage & Retention */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-200">4. Data Storage and Retention</h2>
          <p className="text-gray-300">
            Your message data is stored temporarily on our servers for the purpose of processing and providing services. Once a conversation is completed or after a short retention period for operational purposes, your data is securely deleted.
          </p>

          {/* Section for User Rights */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-200">5. Your Rights</h2>
          <p className="text-gray-300">
            You have the right to request deletion of your message data. To do so, please contact us at the email address provided below.
          </p>

          {/* Section for Contact Information */}
          <h2 className="text-2xl md:text-3xl font-bold text-gray-200">6. Contact Us</h2>
          <p className="text-gray-300">
            If you have any questions or concerns regarding this Privacy Policy or your data, please feel free to contact us at:
          </p>
          <p className="text-blue-300 font-semibold">
            support@elevatemart.com
          </p>
        </div>
      </div>
    </div>
  );
};

export default FacebookPrivacyPolicy;
